import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import axios from 'axios/index';
import animations from './animations';
import globals from '../../globals';
import Heading from '../../elements/Heading';
import PlanResults from '../../modules/PlanResults';
import Errors from '../../elements/Errors';
import Notice from "../../elements/Notice";
import Disclaimer1 from "../../elements/Disclaimer1";
import InternetForm from "../InternetForm";
import PricingBtn from "../../elements/PricingBtn";
import InternalPricingError from "../../elements/InternalPricingError";
import LoaderText from "../../elements/LoaderText";
import { sha256 } from 'js-sha256';

class InternetFormContainer extends Component {

    constructor(props) {
        super(props);

        this.honeypot = 'dob';
        this.state = {
        	address: '',
			first_name: globals.getSessionVar('first_name'),
			last_name: globals.getSessionVar('last_name'),
			company: globals.getSessionVar('company'),
			email: globals.getSessionVar('email'),
			phone: globals.getSessionVar('phone'),
            [this.honeypot]: '', //honeypot
            errors: [],
			plans: []
        };
    }

	componentDidMount() {
		this.controller = globals.genericAnimation(this.content);
	}

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

    handleInputChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.reset();
        animations.showLoader(this);
        setTimeout(() => {
			this.submitCustomerDetails();
		}, 500);
    }

	handleSetAddress(address) {
    	this.setState({address: address});
	}

	submitCustomerDetails() {
		axios.post(this.props.apiUrl, this.state)
			.then(() => {
                globals.pushGA4Events(this.props.submitEvent,
                    {
                        eventInfo: {
                            hashedFirstName: sha256(this.state.first_name),
                            hashedLastName: sha256(this.state.last_name),
                            hashedEmail: sha256(this.state.email),
                            hashedNumber: sha256(this.state.phone),
                            pageCategory: 'Business',
                        }
                    });
				this.getPricing();
			})
			.catch(response => {
				this.reset();
				if (response.response.status === 422) {
					this.processValidation(response.response);
				} else {
					this.handleError(response);
				}
			});
	}

	getPricing() {
		animations.showLoader(this);
		setTimeout(() => {
			this.setState({
				plans: this.props.plans
			}, () => {
				animations.showSuccess(this);
			});
		}, 2000);
	}

	handleCloseError(event) {
		event.preventDefault();
		animations.closeError(this, '#internal-error');
	}

    processValidation(response) {
        let PartnersFormNode = findDOMNode(this),
            errors = response.data.errors;

        for (let key in errors) {
            if (key === this.honeypot) {
                // do nothing
            } else {
                PartnersFormNode.querySelector('.input-' + key + ' .graphic--nao').style.stroke = 'red';
            }

            this.updateErrors(errors[key][0]);
        }

        animations.showErrors(this);
    }

    updateErrors(newError) {
        this.setState(prevState => ({
            errors: [...prevState.errors, newError]
        }));
    }

    handleError(response) {
        this.updateErrors(globals.getGenericErrorMsg());
        animations.showErrors(this);
        globals.handleError(response.message, response);
    }

    reset() {
        this.setState({errors: []});
        animations.reset(this);
    }

    render() {
        return (
            <div className="internet-form-container">
				<div className="inner">
					<div ref={el => this.content = el}>
						<div id="business-fibre-anchor" />
						<Heading title={this.props.title} subTitle={this.props.subTitle} />
						<div className="row form-outer">
							<div className="col-md-10 col-md-offset-1 col-xs-12">
								<form onSubmit={this.handleSubmit.bind(this)}>
									<InternetForm
										state={this.state}
										honeypot={this.honeypot}
										handleSetAddress={this.handleSetAddress.bind(this)}
										handleInputChange={this.handleInputChange.bind(this)}
									/>
									<Errors errors={this.state.errors} />
									<PricingBtn handleSubmit={event => this.handleSubmit(event)}>
										<LoaderText title="Calculating pricing" subTitle="" />
									</PricingBtn>
									<PlanResults plans={this.state.plans}>
										<Notice />
									</PlanResults>
									<Disclaimer1 />
								</form>
								<InternalPricingError handleCloseError={this.handleCloseError.bind(this)} />
							</div>
						</div>
					</div>
				</div>
				<div className="bottom-wave-darkgreen" />
            </div>
        );
    }

}

export default InternetFormContainer;


// WEBPACK FOOTER //
// ./resources/assets/js/forms/InternetFormContainer/InternetFormContainer.js